namespace Matrix.Data {
    export interface SecurityMergePriorityRow {
        Priority?: number;
        SourceCode?: string;
        MergeGroup?: string;
        SelfMatch?: boolean;
        DealParentCode?: boolean;
        Name?: boolean;
        SecurityTypeCode?: boolean;
        LocalCurrencyCode?: boolean;
        ExposureMultiplier?: boolean;
        AssociatedAccountCode?: boolean;
        Sedol?: boolean;
        RIC?: boolean;
        Isin?: boolean;
        Cusip?: boolean;
        Figi?: boolean;
        Ticker?: boolean;
        InternalSecurityCode?: boolean;
        Issuer?: boolean;
        CouponRate?: boolean;
        MaturityDate?: boolean;
        SpLtRating?: boolean;
        SpStRating?: boolean;
        MoodysLtRating?: boolean;
        MoodysStRating?: boolean;
        FitchLtRating?: boolean;
        FitchStRating?: boolean;
        InternalLtRating?: boolean;
        InternalStRating?: boolean;
        CountryOfIssueCode?: boolean;
        CountryOfRiskCode?: boolean;
        CurrencyOfRiskCode?: boolean;
        TradeDate?: boolean;
        EffectiveDate?: boolean;
        BrokerCode?: boolean;
        Strategy?: boolean;
        OptionStyle?: boolean;
        ExerciseStyle?: boolean;
        PutOrCall?: boolean;
        StrikePrice?: boolean;
        StrikeCurrency?: boolean;
        Premium?: boolean;
        PremiumCcy?: boolean;
        PayOrRec?: boolean;
        FixedOrFloat?: boolean;
        FloatIndex?: boolean;
        InflationIndexLag?: boolean;
        InterestTerm?: boolean;
        Spread?: boolean;
        AllIn?: boolean;
        InterestCcy?: boolean;
        PaymentFrequency?: boolean;
        PaymentBusDayConvention?: boolean;
        PaymentCalendar?: boolean;
        FirstPaymentDate?: boolean;
        DayCountBasis?: boolean;
        ResetFrequency?: boolean;
        ResetBusDayConvention?: boolean;
        ResetCalendar?: boolean;
        UnderlyerName?: boolean;
        UnderlyerCcy?: boolean;
        UnderlyerType?: boolean;
        ClearerReference?: boolean;
        RedCode?: boolean;
        CreditEvents?: boolean;
        Guarantor?: boolean;
        SecurityCode?: boolean;
        GicsSector?: boolean;
        GicsIndustryGroup?: boolean;
        GicsIndustry?: boolean;
        GicsSubIndustry?: boolean;
        BorrowerCode?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace SecurityMergePriorityRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'SourceCode';
        export const localTextPrefix = 'Data.SecurityMergePriority';
        export const deletePermission = 'DataAdmin:SecurityMergePriority';
        export const insertPermission = 'DataAdmin:SecurityMergePriority';
        export const readPermission = 'Read:SecurityMergePriority';
        export const updatePermission = 'DataAdmin:SecurityMergePriority';

        export declare const enum Fields {
            Priority = "Priority",
            SourceCode = "SourceCode",
            MergeGroup = "MergeGroup",
            SelfMatch = "SelfMatch",
            DealParentCode = "DealParentCode",
            Name = "Name",
            SecurityTypeCode = "SecurityTypeCode",
            LocalCurrencyCode = "LocalCurrencyCode",
            ExposureMultiplier = "ExposureMultiplier",
            AssociatedAccountCode = "AssociatedAccountCode",
            Sedol = "Sedol",
            RIC = "RIC",
            Isin = "Isin",
            Cusip = "Cusip",
            Figi = "Figi",
            Ticker = "Ticker",
            InternalSecurityCode = "InternalSecurityCode",
            Issuer = "Issuer",
            CouponRate = "CouponRate",
            MaturityDate = "MaturityDate",
            SpLtRating = "SpLtRating",
            SpStRating = "SpStRating",
            MoodysLtRating = "MoodysLtRating",
            MoodysStRating = "MoodysStRating",
            FitchLtRating = "FitchLtRating",
            FitchStRating = "FitchStRating",
            InternalLtRating = "InternalLtRating",
            InternalStRating = "InternalStRating",
            CountryOfIssueCode = "CountryOfIssueCode",
            CountryOfRiskCode = "CountryOfRiskCode",
            CurrencyOfRiskCode = "CurrencyOfRiskCode",
            TradeDate = "TradeDate",
            EffectiveDate = "EffectiveDate",
            BrokerCode = "BrokerCode",
            Strategy = "Strategy",
            OptionStyle = "OptionStyle",
            ExerciseStyle = "ExerciseStyle",
            PutOrCall = "PutOrCall",
            StrikePrice = "StrikePrice",
            StrikeCurrency = "StrikeCurrency",
            Premium = "Premium",
            PremiumCcy = "PremiumCcy",
            PayOrRec = "PayOrRec",
            FixedOrFloat = "FixedOrFloat",
            FloatIndex = "FloatIndex",
            InflationIndexLag = "InflationIndexLag",
            InterestTerm = "InterestTerm",
            Spread = "Spread",
            AllIn = "AllIn",
            InterestCcy = "InterestCcy",
            PaymentFrequency = "PaymentFrequency",
            PaymentBusDayConvention = "PaymentBusDayConvention",
            PaymentCalendar = "PaymentCalendar",
            FirstPaymentDate = "FirstPaymentDate",
            DayCountBasis = "DayCountBasis",
            ResetFrequency = "ResetFrequency",
            ResetBusDayConvention = "ResetBusDayConvention",
            ResetCalendar = "ResetCalendar",
            UnderlyerName = "UnderlyerName",
            UnderlyerCcy = "UnderlyerCcy",
            UnderlyerType = "UnderlyerType",
            ClearerReference = "ClearerReference",
            RedCode = "RedCode",
            CreditEvents = "CreditEvents",
            Guarantor = "Guarantor",
            SecurityCode = "SecurityCode",
            GicsSector = "GicsSector",
            GicsIndustryGroup = "GicsIndustryGroup",
            GicsIndustry = "GicsIndustry",
            GicsSubIndustry = "GicsSubIndustry",
            BorrowerCode = "BorrowerCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
